import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Sede } from '../../../_models/Sede';
import { SearchResult } from '../../../_models/SearchResult';
import { RegistryService } from '../../../_services/registry.service';
import { OrganizzazioniService } from '../../../_services/organizzazioni.service';
import { SaveMessage } from '../../../_helpers/save-message';

@Component({
  selector: 'app-select-anagrafica-sede',
  templateUrl: './select-anagrafica-sede.component.html',
  styleUrls: ['./select-anagrafica-sede.component.scss'],
  standalone: false
})
export class SelectAnagraficaSedeComponent implements OnInit, OnChanges {
  @Input()  anagraficaId = 0;
  @Input()  sedeId = 0;
  @Output() sedeIdChange   = new EventEmitter<number>();
  @Output() sedeChange     = new EventEmitter<Sede>();
  @Input()  label = 'Sede';

  sedeSelezionata: Sede | null = null;
  search = '';
  risultati: Sede[] = [];
  showDropdown = false;
  loading = false;

  constructor(
    private registryService: RegistryService,
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage
  ) {}

  ngOnInit() {
    if (this.anagraficaId > 0 && this.sedeId > 0) {
      this.caricaSedeSelezionata();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Quando cambia l'anagrafica padre, azzera la selezione corrente
    if (changes['anagraficaId'] && !changes['anagraficaId'].firstChange) {
      this.svuota();
    }
  }

  caricaSedeSelezionata() {
    this.loading = true;
    this.registryService.getSediOfAnagraficaFilteredAsync(
      this.organizzazioniService.organizzazioneId,
      this.anagraficaId, '', 0, 100, 'nome', true
    )
      .then((result: SearchResult<Sede>) => {
        const found = (result?.result ?? []).find(s => s.id === this.sedeId);
        if (found) { this.sedeSelezionata = found; }
      })
      .catch(() => this.saveMessage.messageError('Errore nel caricamento della sede.'))
      .finally(() => this.loading = false);
  }

  cercaSedi() {
    if (this.anagraficaId <= 0) { return; }
    this.loading = true;
    this.registryService.getSediOfAnagraficaFilteredAsync(
      this.organizzazioniService.organizzazioneId,
      this.anagraficaId, this.search, 0, 20, 'nome', true
    )
      .then((result: SearchResult<Sede>) => {
        this.risultati   = result?.result ?? [];
        this.showDropdown = true;
      })
      .catch(() => this.saveMessage.messageError('Errore nel caricamento delle sedi.'))
      .finally(() => this.loading = false);
  }

  seleziona(sede: Sede) {
    this.sedeSelezionata = sede;
    this.sedeId          = sede.id;
    this.showDropdown    = false;
    this.risultati       = [];
    this.search          = '';
    this.sedeIdChange.emit(sede.id);
    this.sedeChange.emit(sede);
  }

  svuota() {
    this.sedeSelezionata = null;
    this.sedeId          = 0;
    this.search          = '';
    this.showDropdown    = false;
    this.risultati       = [];
    this.sedeIdChange.emit(0);
    this.sedeChange.emit(null);
  }
}
